var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "63px",
    viewBox: "0 0 60 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CE03DA24-5B05-492E-BE48-3A032B7030EA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12.-Drug-interactions-UI",
    transform: "translate(-1190.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(473.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(717.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6307223,43 C38.3522532,43 38.0690885,42.9509603 37.7930693,42.8472068 C35.8009127,42.0992494 28.7070957,39.1909093 21.0698149,33.1788805 C10.8307669,25.1185308 3.77676048,14.9774372 0.103785536,3.03747685 C-0.277986635,1.79567719 0.426352398,0.481939085 1.67721769,0.10279301 C2.92828714,-0.27554249 4.25183205,0.422969813 4.63401253,1.66456682 C8.02076042,12.6752039 14.5408983,22.0389569 24.0129313,29.4952262 C31.114302,35.085351 37.6387272,37.7626776 39.4689879,38.4500445 C40.6924962,38.9092347 41.3088439,40.2661359 40.8462259,41.480376 C40.4877275,42.4208447 39.5869902,43 38.6307223,43",
    id: "Fill-5",
    fill: "#2D1C45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3892898,63 C33.4865177,63 32.6230502,62.4810694 32.2201262,61.6003404 C31.6678033,60.392685 32.1906991,58.9623047 33.3877416,58.4051808 L54.6315927,48.5203829 L48.820679,32.0719431 L43.987031,43.7105188 C43.4775111,44.9370632 42.0792124,45.5145292 40.8628263,45.0009955 C39.6470575,44.4870466 39.0741563,43.0763856 39.5834704,41.8496337 L46.7986506,24.4772898 C47.17935,23.5604432 48.0720387,22.9748819 49.0651498,23.0008284 C50.050441,23.0278128 50.9180242,23.6629838 51.248924,24.5995498 L59.8609624,48.9768343 C60.2758219,50.1506553 59.733994,51.4494349 58.612474,51.9714791 L35.3877512,62.7781053 C35.0636422,62.9285951 34.7236879,63 34.3892898,63",
    id: "Fill-7",
    fill: "#DF6532"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.eba9a845.svg";
export { ForwardRef as ReactComponent };